module.exports = __webpack_public_path__ + "img/EnergyvsPowerwHBM-min.9a5464b7.png";